var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SearchSection'),(_vm.showMainMessage)?_c('MainMessage'):_vm._e(),_c('CategoriesSection'),(_vm.categoryChange)?_c('ResultsSection',{attrs:{"questions":_vm.questions}}):_vm._e(),_c('CtaSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }